import { useQuery } from "@tanstack/react-query";

import MetaAdAccountService from "services/MetaAdAccount";

// Poll cadence while a Meta sync is in flight, shared by the account rail and
// the section tables so they refresh in lockstep.
export const META_SYNC_POLL_INTERVAL_MS = 2000;

// Reports whether a Meta ad account's Business (``live``) or Sandbox group is
// mid-sync, read from the shared ``["meta-ad-account", accountId]`` cache the
// detail rail already owns. ``enabled: false`` keeps this a pure reader: it
// subscribes to cache updates (so a table re-renders when the rail's polling
// flips a group's status) without issuing its own fetch.
const useMetaSyncInProgress = (accountId, scope) => {
  const { data: account } = useQuery({
    queryKey: ["meta-ad-account", accountId],
    queryFn: () => MetaAdAccountService.get(accountId),
    enabled: false,
  });
  return account?.sync?.[scope]?.status === "pending";
};

export default useMetaSyncInProgress;
